import {Grid} from "@mui/material";
import React from "react";
import './InfoCard.css';

function InfoCard( {title , text , iconClassName , color} ) {
    return <>
        <Grid container className={"infoCardContainer"}>
            <Grid item className={"inofCardTitleContainer"} >
                <h2 className={"infoCardTitle"}>{title}</h2>
            </Grid>
            <Grid item className={"infoCardTextContainer"}>
                <ul className={"custom-list"}>
                    {text.map((text, index) => <li id={index}> <i className={iconClassName} style={{color}}></i> {text}</li>)}
                </ul>

            </Grid>
        </Grid>


    </>




}export default InfoCard;